import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../Shared/Services/auth.service';

@Component({
  selector: 'app-impersonation-expired',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    TranslateModule
  ],
  templateUrl: './impersonation-expired.component.html',
  styleUrls: ['./impersonation-expired.component.scss']
})
export class ImpersonationExpiredComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _authService = inject(AuthService);

  private readonly EXPIRED_FLAG_KEY = 'impersonation_expired';

  readonly email = signal<string | null>(null);

  readonly messageParams = computed(() => ({ email: this.email() ? ` (${this.email()})` : '' }));

  ngOnInit(): void {
    this.resolveExpiryContext();
  }

  private resolveExpiryContext(): void {
    const flag = sessionStorage.getItem(this.EXPIRED_FLAG_KEY);

    if (!flag) {
      this._router.navigate(['/auth/login']);
      return;
    }

    this.email.set(flag !== '1' ? flag : null);
    this._authService.clearAuth();
  }

  returnToLogin(): void {
    sessionStorage.removeItem(this.EXPIRED_FLAG_KEY);
    this._router.navigate(['/auth/login']);
  }
}
